<template>
  <div class="apps-page">
    <!-- 面包屑 -->
    <div class="apps-page-breadcrumb">
      <router-link to="/">{{ $t('nav.home') }}</router-link>
      <span class="sep">/</span>
      <span>{{ $t('home.apps.title') }}</span>
    </div>

    <h1 class="apps-page-title">{{ $t('home.apps.title') }}</h1>

    <AppsGrid mode="section" />
  </div>
</template>

<script>
var AppsGrid = require('../components/AppsGrid.vue').default

module.exports = {
  name: 'AppsPage',
  components: { AppsGrid: AppsGrid }
}
</script>

<style scoped>
.apps-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 36px 48px;
}

.apps-page-breadcrumb {
  font-size: 14px;
  color: #8b8fa3;
  margin-bottom: 18px;
}
.apps-page-breadcrumb a {
  color: #8b8fa3;
  text-decoration: none;
}
.apps-page-breadcrumb a:hover {
  color: #059669;
}
.apps-page-breadcrumb .sep {
  margin: 0 6px;
}

.apps-page-title {
  font-size: 32px;
  font-weight: 700;
  color: #111;
  margin: 0 0 28px;
}

@media (max-width: 1024px) {
  .apps-page { padding: 24px; }
}
@media (max-width: 768px) {
  .apps-page { padding: 16px 12px; }
  .apps-page-title { font-size: 22px; }
}
</style>
